const sortingTypes = ["asc", "desc"] as const;
export default sortingTypes;
